module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/basketballplayer-62291917e34ce23e35e3bdebe194befd.png";